import { render, staticRenderFns } from "./AddContextMenu.vue?vue&type=template&id=c522683c&scoped=true"
import script from "./AddContextMenu.vue?vue&type=script&lang=js"
export * from "./AddContextMenu.vue?vue&type=script&lang=js"
import style0 from "./AddContextMenu.vue?vue&type=style&index=0&id=c522683c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522683c",
  null
  
)

export default component.exports